'use client';

import { useEffect } from 'react';

function isProduction(): boolean {
  try {
    if (typeof import.meta !== 'undefined' && (import.meta as ImportMeta).env) {
      return Boolean((import.meta as ImportMeta).env.PROD);
    }
  } catch {}
  return typeof process !== 'undefined' && process.env?.NODE_ENV === 'production';
}

/**
 * Registers the global service worker. Skipped in development so the SW does
 * not interfere with HMR. The SW lives at `/sw.js` and is scoped to `/`.
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (!isProduction()) return;
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

    const onLoad = () => {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .catch(() => {
          /* swallow — SW registration failure should never break the page */
        });
    };

    if (document.readyState === 'complete') onLoad();
    else window.addEventListener('load', onLoad, { once: true });

    return () => window.removeEventListener('load', onLoad);
  }, []);

  return null;
}
